/* eslint-disable max-len */
export default {
    logo: 'Lemlock - legal and technical support for your cybersecurity',
    menu: {
        threats: 'Bedrohungen',
        offer: 'Angebot',
        contact: 'Kontakt',
        video: 'Video',
        about: 'Über uns',
        estimation: 'Preise'
    }
};



// WEBPACK FOOTER //
// ./src/i18n/de/header.js